import React, { Fragment, Component } from 'react';
import styles from './styles.module.css';

import TEXT from '../../../../../data/text.json';
import TextBox from '../../form-components/text-box';
import EmailNotice from '../../form-components/email-notice';
import Checkbox from '../../../Checkbox';

export default class EmailInput extends Component {
  state = {
    emailSaved: false
  };

  componentDidMount() {
    const foundEmail = window.localStorage.getItem('saved-email');

    if (foundEmail) {
      this.setState({ emailSaved: true });
      this.props.setEmailValue({ target: { value: foundEmail } });
    }
  }

  setEmailValue = event => {
    this.props.setEmailValue(event);
    if (this.state.emailSaved) {
      window.localStorage.setItem('saved-email', this.props.emailValue);
    }
  };

  toggleSaveChoice = event => {
    if (this.state.emailSaved) {
      // Disabling so clear stored value
      console.log('clearing');
      window.localStorage.setItem('saved-email', '');
    } else {
      console.log('saving', this.props.emailValue);
      window.localStorage.setItem('saved-email', this.props.emailValue);
    }

    this.setState(state => ({ emailSaved: !state.emailSaved }));
  };

  render() {
    return (
      <Fragment>
        <TextBox
          required
          type="email"
          id={TEXT.FORMS.emailId}
          label={TEXT.FORMS.emailLabel}
          placeholder={TEXT.FORMS.emailPlaceholder}
          value={this.props.emailValue}
          onChange={this.setEmailValue}
        />

        <label
          className={styles.checkboxLabel}
          htmlFor="save-email"
          onClick={event => {
            event.preventDefault();
            this.toggleSaveChoice(event);
          }}
        >
          <Checkbox
            borderStyle
            color="#fff"
            type="checkbox"
            id="save-email"
            value={this.state.emailSaved}
            onChange={this.toggleSaveChoice}
          />
          <span>Remember email address</span>
        </label>

        <EmailNotice />
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/contribution-form/form-components/email-input/index.js